import { cn } from "@/lib/utils";

export const selectionRowClassName = cn(
  "group h-auto w-full cursor-pointer justify-start gap-3 rounded-xl px-3 py-3 text-left",
  "hover:bg-softiq-secondary-shade-100/60",
  "data-[active=true]:bg-softiq-secondary-shade-100 data-[active=true]:shadow-sm",
  "dark:hover:bg-white/[0.06] dark:data-[active=true]:bg-white/[0.09] dark:data-[active=true]:shadow-none",
);

export function getSelectionIconClassName(isActive: boolean) {
  return cn(
    "flex size-9 shrink-0 items-center justify-center rounded-lg bg-softiq-secondary-shade-200 text-softiq-primary transition-colors",
    isActive && "bg-softiq-primary text-white",
    "dark:bg-white/10 dark:text-softiq-secondary dark:group-data-[active=true]:bg-softiq-secondary dark:group-data-[active=true]:text-softiq-primary",
  );
}

export const selectionCheckClassName =
  "flex size-6 shrink-0 items-center justify-center rounded-full bg-softiq-primary text-white dark:bg-softiq-secondary dark:text-softiq-primary";
